import { AfterContentInit, Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { ActivatedRoute,Router, NavigationEnd } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterContentInit {

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
     
  ) {
    //If navigation changes then we have to update routeID
    this.router.events.subscribe((val) => {
      if(val instanceof NavigationEnd){

        this.routeID = val.url;
        this.ActiveLink();
      }
    });


   }
  businessID = this.authService.getTokenData().businessID;
  userID = this.authService.getTokenData().id;
  tokenData = this.authService.getTokenData();
  lastUpdated = new Date();
  //RouteID is current route
  routeID;
  authToken = localStorage.getItem('auth');
  businessData;
  numbers;
  sysInterval;
  selected_item = "";

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  ngOnInit(): void {
    this.calculateSidebarData();
    this.sysInterval = setInterval(() => {
      this.calculateSidebarData();
      //2min
    }, 120000)
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
    this.businessData = JSON.parse(localStorage.getItem('company_'+this.businessID))[0];
    //this.ActiveLink();
    },800)
  }

  ngOndestroy(): void {
    //remove interval
    this.sysInterval = clearInterval(this.sysInterval); 
  }

  logout(){
    this.authService.doLogOut(true);
  }

  ActiveLink() {

    if(this.routeID.includes('/users/home')){
      var elm = document.getElementById("dashboard")
      this.setActiveLink(elm);
      this.selected_item = "dashboard";
    }
    else if(this.routeID.includes('/quickapplication')){
      var elm = document.getElementById("quickapplication")
      this.setActiveLink(elm);
      this.selected_item = "quickapplication";
    }
    else if(this.routeID.includes('/openings/single-opening')){
      var elm = document.getElementById("openings")
      setTimeout(() => {
        this.calculateSidebarData();
        },1000)
      this.setActiveLink(elm);
    }
    else if(this.routeID.includes('/openings')){
      var elm = document.getElementById("openings")
      this.setActiveLink(elm);
      this.selected_item = "openings";
    }
    else if(this.routeID.includes('/wishlist')){
      var elm = document.getElementById("wishes")
      this.setActiveLink(elm);
      this.selected_item = "wishes";
    }
    else if(this.routeID.includes('/messages')){
      var elm = document.getElementById("messages");
      setTimeout(() => {
      this.calculateSidebarData();
      },1000)
      this.setActiveLink(elm);
      this.selected_item = "messages";
    }
    else if(this.routeID.includes('/company-details')){
      var elm = document.getElementById("settings")
      this.setActiveLink(elm);
      this.selected_item = "settings";
    }
    else if(this.routeID.includes('/edit-business')){
      var elm = document.getElementById("settings")
      this.setActiveLink(elm);
      this.selected_item = "settings";
    }
    else if(this.routeID.includes('/register-user')){
      var elm = document.getElementById("settings")
      this.setActiveLink(elm);
      this.selected_item = "settings";
    }
    else if(this.routeID.includes('/subgroup')){
      var elm = document.getElementById("settings")
      this.setActiveLink(elm);
      this.selected_item = "settings";
    }
    else if(this.routeID.includes('/forum')){
      var elm = document.getElementById("forum")
      this.setActiveLink(elm);
    }
    else if(this.routeID.includes('/business-interests')){
      var elm = document.getElementById("interested")
      this.setActiveLink(elm);
      this.selected_item = "interested";
    }
    else if(this.routeID.includes('/lists')){
      var elm = document.getElementById("lists")
      this.setActiveLink(elm);
      this.selected_item = "lists";
    }
    else if(this.routeID.includes('/search-alerts')){
      var elm = document.getElementById("search-alerts")
      this.setActiveLink(elm);
      this.selected_item = "search-alerts";
    }

    }
    setActiveLink(elm){

      var elms = document.getElementsByClassName("nav-link-active");
      for (let i = 0; i < elms.length; i++) {
        elms[i].classList.remove("nav-link-active");
      }

      elm.classList.add("nav-link-active");
    }

    calculateSidebarData(){
      this.authToken = localStorage.getItem('auth');
      var newhttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${localStorage.getItem('auth')}`  }),
        withCredentials: true,
      };
      this.http.get(environment.MESSAGES_SIDEBAR, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.numbers = res.message;

            }
          else {
            console.log('sivupalkki failed')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })

    }

}
